import React, { ReactElement, useRef, useEffect } from 'react';
import ReactHowler from 'react-howler';
import { useDispatch, useSelector } from 'react-redux';
import {
  AudioPlayerStateType,
  actions as AudioPlayerActions,
} from '@/components/Player/modules/reducers/audioPlayer';

const HowlerAudioPlayer = (): ReactElement => {
  const audioPlayer: AudioPlayerStateType = useSelector(
    (state: { audioPlayer: AudioPlayerStateType }) => state.audioPlayer,
  );

  const dispatch = useDispatch();
  const previousSource = useRef('');
  const audioRef = useRef<any>(null);
  const previousPlayingStatus = useRef(false);
  const howlerInstance: any = useRef(undefined);

  useEffect(() => {
    previousSource.current = audioPlayer.source;
    previousPlayingStatus.current = audioPlayer.playing;
  });

  const onEnd = () => {
    // for restarting the sound after ending
    previousSource.current = '';
    dispatch({
      type: AudioPlayerActions.endAudio.type,
    });
  };

  const onLoad = () => {
    if (audioRef?.current) {
      howlerInstance.current = audioRef.current;
      dispatch({
        type: AudioPlayerActions.loadAudio.type,
        payload: howlerInstance.current,
      });
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      howlerInstance.current = audioRef.current;
      dispatch({
        type: AudioPlayerActions.loadAudio.type,
        payload: howlerInstance.current,
      });
    }
  }, [audioRef]);

  if (audioPlayer.source !== '' && audioPlayer.loaded) {
    return (
      <ReactHowler
        src={audioPlayer.source}
        playing={audioPlayer.playing}
        preload={true}
        mute={audioPlayer.mute}
        loop={false}
        html5={true}
        onEnd={onEnd}
        onLoad={onLoad}
        ref={(ref) => {
          audioRef.current = ref;
        }}
      />
    );
  }

  return <div />;
};

export default HowlerAudioPlayer;
